// extracted by mini-css-extract-plugin
export default {"Content":"OSfd2qjO0ZD8SzewUnjjuw=="};